import React from 'react';
import { Pagination as BPagination } from 'react-bootstrap';

export default function Pagination({ page, totalPages, onChange }) {
  if (!totalPages || totalPages < 1) return null;
  const items = [];
  const max = totalPages;
  const win = 2;
  const start = Math.max(1, page - win);
  const end = Math.min(max, page + win);

  items.push(
    <BPagination.First key="first" disabled={page <= 1} onClick={() => onChange(1)} />
  );
  items.push(
    <BPagination.Prev key="prev" disabled={page <= 1} onClick={() => onChange(page - 1)} />
  );
  if (start > 1) {
    items.push(<BPagination.Item key={1} onClick={() => onChange(1)}>{1}</BPagination.Item>);
    if (start > 2) items.push(<BPagination.Ellipsis key="e1" disabled />);
  }
  for (let i = start; i <= end; i++) {
    items.push(
      <BPagination.Item key={i} active={i === page} onClick={() => onChange(i)}>
        {i}
      </BPagination.Item>
    );
  }
  if (end < max) {
    if (end < max - 1) items.push(<BPagination.Ellipsis key="e2" disabled />);
    items.push(<BPagination.Item key={max} onClick={() => onChange(max)}>{max}</BPagination.Item>);
  }
  items.push(
    <BPagination.Next key="next" disabled={page >= max} onClick={() => onChange(page + 1)} />
  );
  items.push(
    <BPagination.Last key="last" disabled={page >= max} onClick={() => onChange(max)} />
  );

  return <BPagination className="mb-0" data-testid="pagination">{items}</BPagination>;
}
